import { Message } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';

interface ConversationMessages {
  messages: Message[];
  count: number;
}

export default (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<ConversationMessages>(
    'GET',
    `${APIV2_URL}/conversation/${conversationId}/messages`,
  );
